<template>
  <!-- eslint-disable-next-line vue/multiline-html-element-content-newline -->
  <p class="description break-word">
    <!--
  --><slot />
  </p>
</template>

<style scoped>
.bold {
  font-weight: var(--font-weight-bold) !important;
}
.description {
  font-size: var(--font-size-16px);
  font-weight: var(--font-weight-regular);
  white-space: pre-line;
}
.description.omit-long-text {
  white-space: nowrap;
}
.gray-1 {
  color: var(--font-gray-1);
}
.gray-3 {
  color: var(--font-gray-3);
}
.main-title + .description {
  margin-top: var(--base-12px);
}
.sub-title + .description {
  margin-top: var(--base-4px);
}
</style>
